
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support/data-integration",
      function () {
        return require("private-next-pages/support/data-integration/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/support/data-integration"])
      });
    }
  